/* eslint-disable */
import * as util from "@/api/window24hours";

const state = {
};


const mutations = {

};

const actions = {
    listData({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.listData(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    downloadExcelContact({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.downloadExcelContact(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    downloadExcelBc({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.downloadExcelBc(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/window24hours.js